class Work {
    constructor (type , name, description , year , technologies, url, screenshot , logo){
        this.type = type;
        this.name = name;
        this.description = description;
        this.year = year;
        this.technologies = technologies;
        this.url = url;
        this.screenshot = screenshot;
        this.logo = logo;
    }
}

export default Work;